import { FormattedMessage } from 'dibs-react-intl';

export const readMore = (
    <FormattedMessage id="PdpSharedDealerDetails.readMore" defaultMessage="Read More" />
);

export const moreAboutSeller = (
    <FormattedMessage
        id="PdpSharedDealerDetails.moreAboutSeller"
        defaultMessage="More About the Seller"
    />
);

export const learnMore = (
    <FormattedMessage id="PdpSharedDealerDetails.LearnMore" defaultMessage="Learn More" />
);
